import { PROCESS_STEPS } from '../mock/data';

export default function Process() {
  return (
    <section id="process" className="py-24 lg:py-32 bg-ink-soft relative overflow-hidden border-y border-white/5">
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle at 20% 30%, #d4a13a 0%, transparent 45%)' }} />

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <div className="max-w-2xl">
          <div className="eyebrow">How It Works</div>
          <h2 className="section-title">A dead-simple four-step process.</h2>
          <p className="section-lede">
            No sales pressure. No mystery pricing. Just a straight line from &ldquo;I need a fence&rdquo; to &ldquo;wow, that&rsquo;s a fence.&rdquo;
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {PROCESS_STEPS.map((step, idx) => (
            <div key={step.n} className="relative group">
              <div className="rounded-md border border-white/10 bg-ink-panel p-6 h-full hover:border-gold/60 transition-colors">
                <div className="font-display text-6xl text-gold leading-none">{step.n}</div>
                <h3 className="mt-4 font-display uppercase text-2xl text-cream tracking-tight">{step.title}</h3>
                <p className="mt-2 text-cream/65 text-sm leading-relaxed">{step.desc}</p>
              </div>
              {idx < PROCESS_STEPS.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-gold/40" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
